<template>
	<div class="top">
		<div class="head">
			<div>
				
			</div>
			<div class="head_right">
				<div class="head_time">
					<span v-if="lang==0">{{year}}年{{month}}月{{day}}日</span>
					<span v-if="lang==1">{{monthnum[month-1]}}{{day}}.{{year}}</span>
					<span v-if="lang==2">{{year}}年{{month}}月{{day}}日</span>
					<span v-if="lang==3">{{year}}년{{month}}월{{day}}일</span>
				</div>
				<div class="language">
					<div class="language_box">
						{{langtext[lang]}}
						<img class="l_sj" src="@/assets/home/lang.png" alt="" />
					</div>
					<div class="language_optbig">
						
						<div class="language_optbox">
							<div class="language_opt" @click="langfun(0)">
								中文简体
							</div>
							<div class="language_opt" @click="langfun(1)">
								EN
							</div>
							<div class="language_opt" @click="langfun(2)">
								JP
							</div>
							<div class="language_opt" @click="langfun(3)">
								KR
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		
		<img class="logo" src="@/assets/home/logo.png" alt="" />
		
		<div class="top_opt">
			<div class="opt_box" v-for="(item,index) in list.slice(0,5)" :key="index" @click="optfun(index,0,'true')">
				<div class="opt_top">
					<div class="opt_cn">
						{{item.name}}
					</div>
					<div class="opt_en" v-if="lang==0">
						{{item.remark}}
					</div>
				</div>
				<div class="minbox" v-if="item.children.length">
					<div class="min_opt">
						<div class="min_optbox" v-for="(item,index2) in item.children" :key="item.name" @click.stop="optfun(index,index2)">
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
			<div class="separate"></div>
			<div class="opt_box" v-for="(item,index) in list.slice(5,10)" :key="index+5"  @click="optfun(index+5,0,'true')">
				<div class="opt_top">
					<div class="opt_cn">
						{{item.name}}
					</div>
					<div class="opt_en">
						{{item.remark}}
					</div>
				</div>
				<div class="minbox" v-if="item.children.length">
					<div class="min_opt">
						<div class="min_optbox" v-for="(item,index2) in item.children" :key="item.name" @click.stop="optfun(index+5,index2)">
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import { menuList,article } from "@/api/article";
	
	export default {
		data() {
			return {
				
				list:[],
				
				//
				day:new Date().getDate(),
				month:new Date().getMonth() + 1,
				year:new Date().getFullYear(),
				houer: new Date().getHours(),
				minu: new Date().getMinutes(),
				monthnum:['Jan.','Feb.','Mar.','Ari.','May.','Jun.','Jul.','Aut.','Sep.','Oct.','Nov.','Dec.'],
				
				langtext:["中文简体","EN","JP","KR"],
				lang: 0,
				langlist:['zh','en','jp','kor'],
			}
		},
		created(){
			this.lang = JSON.parse(localStorage.getItem("langs")) || 0
			
			if(JSON.parse(localStorage.getItem("ids"))){
				this.list = JSON.parse(localStorage.getItem("ids"))
				
				menuList({
					parentId:0,
					language: this.langlist[this.lang],
					belong:'site',   //site,mobile,offiaccount,mini 网站，手机，公众，小程序
				})
				.then((res) => {
					//头部菜单
					this.list = res.data;
					localStorage.setItem("ids", JSON.stringify(this.list));
				})
				.catch((error) => {
					console.log(error);
				});
			}else{
				menuList({
					parentId:0,
					language: this.langlist[this.lang],
					belong:'site',   //site,mobile,offiaccount,mini 网站，手机，公众，小程序
				})
				.then((res) => {
					//头部菜单
					this.list = res.data;
					localStorage.setItem("ids", JSON.stringify(this.list));
				})
				.catch((error) => {
					console.log(error);
				});
			}
		},
		methods:{
			
			optfun(e , a , c){
				if(e==0){
					if(this.$route.name == 'home'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'home',query:{}})
					}
				}
				if(e==1){
					if(this.$route.name == 'about'){
						if(c){
							this.$router.push({name:'refresh',query:{time: new Date().getMilliseconds()}})
						}else{
							this.$router.push({name:'refresh',query:{optnum:a,time: new Date().getMilliseconds()}})
						}
					}else{
						if(c){
							this.$router.push({name:'about',query:{}})
						}else{
							this.$router.push({name:'about',query:{optnum:a}})
						}
					}
				}
				if(e==2){
					if(this.$route.name == 'beauty'){
						this.$router.push({name:'refresh',query:{optnum:a}})
					}else{
						this.$router.push({name:'beauty',query:{optnum:a}})
					}
				}
				if(e==3){
					if(this.$route.name == 'scenery'){
						this.$router.push({name:'refresh',query:{optnum:a}})
					}else{
						this.$router.push({name:'scenery',query:{optnum:a}})
					}
				}
				if(e==4){
					if(this.$route.name == 'virtual'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'virtual',query:{}})
					}
				}
				if(e==5){
					if(this.$route.name == 'travel'){
						if(c){
							this.$router.push({name:'refresh',query:{time: new Date().getMilliseconds()}})
						}else{
							this.$router.push({name:'refresh',query:{optnum:a,time: new Date().getMilliseconds()}})
						}
					}else{
						
						if(c){
							this.$router.push({name:'travel',query:{}})
						}else{
							
							this.$router.push({name:'travel',query:{optnum:a}})
						}
					}
				}
				if(e==6){
					if(this.$route.name == 'serves'){
						this.$router.push({name:'refresh',query:{optnum:a}})
					}else{
						this.$router.push({name:'serves',query:{optnum:a}})
					}
				}
				if(e==7){
					if(this.$route.name == 'news'){
						this.$router.push({name:'refresh',query:{optnum:a}})
					}else{
						this.$router.push({name:'news',query:{optnum:a}})
					}
				}
				if(e==8){
					if(this.$route.name == 'contact'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'contact',query:{}})
					}
				}
				if(e==9){
					if(this.$route.name == 'book'){
						this.$router.push({name:'refresh',query:{optnum:a}})
					}else{
						this.$router.push({name:'book',query:{optnum:a}})
					}
				}
			},
			
			
			
			langfun(e) {
				this.lang = e; //选择语言文字  第几个
				localStorage.setItem("langs", e);
				
				menuList({
					parentId:0,
					language: this.langlist[this.lang],
					belong:'site',   //site,mobile,offiaccount,mini 网站，手机，公众，小程序
				})
				.then((res) => {
					//头部菜单
					var ids = res.data;
					localStorage.setItem("ids", JSON.stringify(ids));
					
					
					if(this.$route.name == 'home'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'home',query:{}})
					}
				})
				.catch((error) => {
					console.log(error);
				});
			},
			
		}
		
	}
</script>

<style scoped lang="less">
	.top{
		width: 100vw;
		height: 110px;
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		color: #333333;
		background-image: linear-gradient(to bottom, #fff, rgba(255, 255, 255, 0.1));
	}
		.logo{
			width: 94px;
			height: 98px;
			position: absolute;
			top: 6px;
			left: 50%;
			transform: translateX(-50%);
		}
	.head{
		height: 46px;
		width: 100%;
		box-sizing: border-box;
		padding: 0 62px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #c9cbcd;
	}
	
	.head_right{
		display: flex;
		align-items: center;
	}
	.head_time{
		font-size: 14px;
		margin-right: 21px;
	}
	// 
	.language{
		position: relative;
	}
	.language_box{
		width: 104px;
		height: 27px;
		border-radius: 5px;
		background-color: #333333;
		font-size: 14px;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.l_sj{
		width: 14px;
		height: 7px;
		transform: rotate(-90deg);
	}
	
		.language:hover{
			.l_sj{
				transform:rotate(0deg) translateY(2px);
			}
			.language_optbig{
				display: block;
			}
		}
	
	.language_optbig{
		display: none;
		position: relative;
		z-index: 20;
	}
	
	.language_optbox{
		width: 104px;
		box-sizing: border-box;
		padding: 6px 4px;
		border: 2px solid #333333;
		position: absolute;
		top: 0px;
		left: 0px;
		background-color: #fff;
		
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.language_opt{
		height: 29px;
		line-height: 29px;
		font-size: 14px;
		color: #021f08;
		border-bottom: 1px solid transparent;
	}
		.language_opt:hover{
			border-bottom: 1px solid #021f08;
		}
	
	// 
	.top_opt{
		display: flex;
		box-sizing: border-box;
		padding: 0 60px;
	}
	.opt_box{
		width: 150px;
		height: 56px;
		position: relative;
	}
	.opt_top{
		width: 150px;
		height: 56px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.opt_cn{
		font-size: 16px;
	}
	.opt_en{
		font-size: 12px;
		text-transform:uppercase;
	}
	.minbox{
		display: none;
	}
	.min_opt{
		width: 150px;
		padding: 13px 0 13px 0;
		background-color: rgba(0, 0, 0, .3);
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.min_optbox{
		font-size: 16px;
		color: #fff;
		height: 42px;
		line-height: 42px;
		border-bottom: 5px solid transparent;
	}
		.min_optbox:hover{
			color: #2cad42;
			border-bottom: 5px solid #2cad42;
		}
	
	.opt_box:hover{
		.minbox{
			display: block;
		}
	}
	.separate{
		width: 300px;
	}
	
	
</style>